import classNames from 'classnames';

export const HorizontalDivider: React.FC<{ className?: string }> = ({ className }) => {
  return <div className={classNames('bg-gradient-to-r from-gray-gallery-darker h-[0.0625rem] -mx-3 my-3', className)} />;
};

export const GrayGradientDivider: React.FC<{ className?: string }> = ({ className }) => {
  return <div className={classNames('bg-gradient-to-r from-gray-gallery-darker h-[0.0625rem]', className)} />;
};
